export const PROTECT_TABS = [
  "estudios",
  "contratos",
  "reclamaciones",
  "fechasClave",
] as const;

export type ProtectTab = (typeof PROTECT_TABS)[number];

export type ClaimsSubTab = "porReclamar" | "reclamados";

export type ProtectNavigation = { tab: ProtectTab; claimsTab?: ClaimsSubTab };

export const isProtectTab = (value: string): value is ProtectTab =>
  PROTECT_TABS.some((tab) => tab === value);
